export type SeatMapViewMode = '2D' | '3D';

export const SEAT_MAP_VIEW_MODE_KEY = 'seat-map-view-mode';

export function parseSeatMapViewMode(raw: string | null | undefined): SeatMapViewMode {
    return raw === '3D' ? '3D' : '2D';
}

export function readSeatMapViewMode(storage: Pick<Storage, 'getItem'> | undefined): SeatMapViewMode {
    try {
        return parseSeatMapViewMode(storage?.getItem(SEAT_MAP_VIEW_MODE_KEY));
    } catch {
        return '2D';
    }
}

export function writeSeatMapViewMode(storage: Pick<Storage, 'setItem'> | undefined, mode: SeatMapViewMode): void {
    try {
        storage?.setItem(SEAT_MAP_VIEW_MODE_KEY, mode);
    } catch {
        // Private windows and blocked site data: the choice just isn't remembered.
    }
}

export function resolveSeatMapViewMode(stored: SeatMapViewMode, isWebGLSupported: boolean): SeatMapViewMode {
    return isWebGLSupported ? stored : '2D';
}
